import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{}} QuantityInputProps
 */

/**
 * QuantityInput QuantityInput.
 * @augments {Base<QuantityInputProps>}
 */
export default class QuantityInput extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'QuantityInput',
    refs: ['input', 'minusBtn', 'plusBtn'],
    emits: ['change'],
    options: {
      nicename: {
        value: '',
        type: String,
      },
    },
  };

  /**
   * Return input value
   * @returns {number}
   */
  get inputValue() {
    return Number.parseInt(this.$refs.input.value);
  }

  /**
   *
   */
  onPlusBtnClick() {
    this.changeInput(Number.parseInt(this.inputValue) + 1);
  }

  /**
   *
   */
  onMinusBtnClick() {
    this.changeInput(Math.max(0, Number.parseInt(this.inputValue) - 1));
  }

  /**
   * Change input value
   * @param  {string} newValue new value
   * @returns {void}
   */
  changeInput(newValue) {
    this.$refs.input.value = newValue;
    this.$emit('change');
  }
}
